// extracted by mini-css-extract-plugin
export default {"page":"HT","heading":"IT","subheading":"JT","flavorbox":"KT","inner":"LT","image":"MT","label":"NT","flavorselect":"OT","arrow":"PT","flavorswrap":"QT","flavorsheader":"RT","flavorsnav":"ST","flavorsinner":"TT","cancelbtn":"UT","flavorsbottom":"VT","retakebtn":"WT","continueBtn":"XT","drawerinner":"YT","videowrap":"ZT","flavorsbottomnav":"aU"};
    if(module.hot) {
      // 1714654895812
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  